var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    {
      staticClass: "inline-flex items-start",
      class: { "text-disabled": _vm.disabled },
    },
    [
      _c("input", {
        ref: "indeterminate",
        staticClass: "form-checkbox me-3",
        class: _vm.checkBoxClasses,
        attrs: { type: "checkbox", disabled: _vm.disabled || _vm.isReadOnly },
        domProps: { checked: _vm.value },
        on: { change: _vm.change },
      }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }